const { resolve } = require("path");

module.exports = {
  module: {
    load: (ns, lng) => {
      const context = require.context(`./locales`, true, /.json$/, "lazy");
      return context(`./${lng}/${ns}.json`);
    },
    getFilepath: (ns, lng) => {
      return resolve(__dirname, "..", "locales", lng, ns) + ".json";
    },
    namespaces: ["validators"],
    langs: ["en", "ru", "es"],
  },
};
